import React, { type ReactElement } from 'react';

interface IconAppleProps {
  width?: number;
  height?: number;
  className?: string;
}

export function IconApple({ width = 15, height = 19, className }: IconAppleProps): ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 15 19"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.96013 3.63451C9.33196 4.39023 8.32688 4.98629 7.3218 4.90114C7.19616 3.87932 7.68823 2.79364 8.26406 2.12307C8.89224 1.34606 9.99154 0.792576 10.8815 0.75C10.9862 1.81439 10.5778 2.8575 9.96013 3.63451ZM10.871 5.10337C9.41571 5.01822 8.16983 5.94424 7.47884 5.94424C6.77738 5.94424 5.71995 5.14595 4.5683 5.16724C3.07115 5.18852 1.6787 6.05068 0.914417 7.42375C-0.65602 10.1699 0.506103 14.2359 2.02419 16.4711C2.76753 17.5781 3.65745 18.7915 4.83004 18.7489C5.93981 18.7063 6.37954 18.0145 7.71964 18.0145C9.07022 18.0145 9.45759 18.7489 10.6302 18.7276C11.8447 18.7063 12.6089 17.6207 13.3523 16.5137C14.2003 15.2577 14.5458 14.0336 14.5667 13.9698C14.5458 13.9485 12.2216 13.0438 12.2006 10.3189C12.1797 8.0411 14.0328 6.95542 14.1166 6.89156C13.0696 5.31625 11.4363 5.14595 10.871 5.10337Z"
        fill="black"
      />
    </svg>
  );
}
